import React, { Component } from 'react';
import './mystyles.scss'
import logo from './logo.svg';
import 'bulma/css/bulma.css'
import 'bulma'
import './App.css';
//Component
import Navbar from "./component/header/header.js"
import Landing from "./component/landing/landing.js"
import  Home from "./component/home/home.js"
import   Dashboard from "./component/dashboard/dashboard.js"
import   Public from "./component/public/public.js"
import   Contact from "./component/public/contact.js"
import   About from "./component/public/about.js"
//import   Admission from "./component/public/admission.js"
import   Signup from "./component/signup/signup.js"
import   SignIn from "./component/login/login.js"
import   Activity from "./component/activity/activity.js"
import   FormBuild from "./component/form/form.js"
import   Setting from "./component/setting/setting.js"
import MoreSetting from './component/setting/moresetting';
import   Phone from "./component/phone/phone.js";
import AuthService from "./component/api/authentication.js";
import School from "./component/school/school.js"
import Search from "./component/search/search.js"
import Payment from "./component/payment/payment.js"
import Bill from "./component/payment/bill.js"
import News from "./component/public/news.js"
import Build  from "./component/build/build.js"
import Display  from "./component/build/dispaly.js"
import Info from "./component/info/info"
import Category from "./component/category/category.js"
import Catalog from "./component/catalog/catalog"
import localforage from 'localforage';
import withTracker from './withTracking';
import Page404 from "./component/page/page404.js"
import Londing from "./component/page/loading"
import AboutUs from "./component/page/about.js"
import Career from "./component/page/careers.js"
import Eventcreate from "./component/create/event"
import Eventedit from "./component/create/eventedit"
import Eventform from "./component/create/eventform"
import Eventshow from "./component/eventshow/eventshow"
import NewCampany from "./component/company/newcompany"
import Campany from "./component/company/company"
import profile from "./component/company/profile"
import website from "./component/company/website"
import  Message from "./component/company/message"
import  Product from "./component/company/prodcut"
import  NewProduct from "./component/company/newproduct"
import  ProductDetail from "./component/company/productdetail"
import Testing from "./component/testing/testing.js"
import Testing1  from "./component/testing/testing1"

// import Page404 from "./component/page/Page404.js"
// import  Header  from './component/header/herder.js'
// router 


import 'bulma/css/bulma.css';

import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  Switch 
} from 'react-router-dom'
import Profile from './component/company/profile';


const styles = {
  fontFamily: 'sans-serif',
  textAlign: 'center',
};

const pages = ['about', 'contact', 'sitemap'];


const Auth = new AuthService
// https://uvune-events.herokuapp.com
class App extends Component {

  constructor(props){
    super(props)
    this.state ={
      domain: 'https://exam-end.herokuapp.com', 
      localApi:'http://localhost:4000', 
      isAuthenticated : false,
      errorAuth : false,
      isLoaded : true,
      pageLoading:false,
      image:"",
      categorys: [],
       user:[],
      //  IfuserEmpty : true,
       disableLink:false,
       isFirst : true,
       phone_one : "",
       address :"",
       noerorrpage : false,
       organizers : [],
       organizers404 : false,
       paymenItem : [],
       hidevan : false
       
    }

  }


  componentDidMount(){
     this.setState({
      pageLoading : true
    })
    if(Auth.loggedIn()){
        if (!this.setState.isAuthenticated && !this.state.errorAuth){
          this.setState({
            pageLoading : false
          })
          // console.log("  getProfile()",  Auth.getProfile())
          const requestOptions = {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' },  
          };
          // var email = "admin@peppement.com"
          return fetch(this.state.domain+"/school/"+ Auth.getProfile().id, requestOptions )
          .then(res => res.json())
          .then(res => {
                console.log("school data------infor", res)

              this.setState({
                isAuthenticated : true,
                pageLoading : true,
                errorAuth : false,
                organizers404:true,
                // platform_admin : res.is_platform_admin,
                user : res.data,
          
              })

           
            return res;
          }).catch(err => err);
      }
    }else{
      //  console.log("check if error state is call")
      this.setState({
        isAuthenticated : false,
        errorAuth : true,
      })
      // console.log("error state", this.state.errorAuth)
      
    }
    
       
  }

  isEmpty=(val)=>{
    return (val === undefined || val === null || val.length <= 0) ? true : false;
}

  check_Gloupdate=(data)=>{
    // console.log("login  ======----> ", data)
    this.setState({
      platform_admin :data
    })
  }

  organizers404=(data)=>{
    this.setState({
      organizers404 : data
    })
  }

  setGlobalorganizers=(data)=>{
    this.setState({
     organizers:data,
     organizers404 :true
    })
    // this.setGlobalpayer(data)
    // console.log("data -------> setGlobalpayer--->", data)
  }

  

  getUser = ( userData) => {
      // console.log("recieved user users ====", userData)
      this.setState({
        user: userData,
        // platform_admin : userData.is_platform_admin
      }) 
      // console.log("recieved user data disble ===", this.state.platform_admin)
    }
    
    setGlobalpayer=(data)=>{
      const requestOptions = {
        method: 'GET', 
        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
      };
      fetch(this.state.domain+"/payment-item?organizers_id="+data, requestOptions)
      .then(res => res.json())
      .then((result)=>{
        // console.log("data -------> setGlobalpayer--->1", result)
    
        this.state({
          paymentItem:result
        })
             
      }).catch( (error) => {

 });
      // console.log("data -------> setGlobalpayer--->", data)
    }

   setGlobalAuthState = () => {

    const auth = Auth.getToken();

    if(auth){
      this.setState({
        isAuthenticated: true
      }) 
   }
  }


  noerorrpage = (data) =>{
    //  console.log("=====================================",data)
     if(data){
      // console.log("yes=====================================",data)
      this.setState({
        noerorrpage : true
       })
     }else{
      // console.log(" no=====================================",data)
      this.setState({
        noerorrpage : false
       })
     }
     
     
  }

  

 

  logout =()=>{
    const auth = Auth.getToken();
    //  console.log("app view", ) 
    if(!auth){
      this.setState({
        isAuthenticated: false,
        errorAuth : true
      }) 
   }
  //  console.log("app view check auth", this.state.isAuthenticated, this.state.errorAuth ) 
  }

  closenav = (data) =>{
    // console.log("App data ===----->",data)
    this.setState({
      hidevan : data
    })
  }


  render() {
   
  
    // console.log("state.IfuserEmpty=====",this.state.IfuserEmpty)
    // console.log("users", this.state.user)
    // console.log("=================================", this.state.noerorrpage)
    return (
      <Router>
      
      <div >
      <div class="pageloader"></div>
      
                  <div class="infraloader is-active"></div>
                    
                      <Navbar isAuthenticated={this.state.isAuthenticated} pages={pages} 
                       organizers404={ this.state.organizers404}  organizer={this.state.organizers} logout={this.logout} />  
                     
                 
               
                    {/* {
                      this.state.isAuthenticated ?
                         <Navbar pages={pages}  logout={this.logout} />  
                      :
                     
                         <div></div>
                      
                      
                    
                    
                    }    */}
                

                  
              <Route path="/dashboard"  exact  render={ props => {
                // console.log("is this suthenticated?", this.state.isAuthenticated);
                    if(this.state.errorAuth || this.state.isAuthenticated ){
                    return  <Dashboard {...props } noerorrpage={this.noerorrpage}  organizer={this.state.organizers}  
                        user={this.state.user} logout={this.logout} isAuthenticated={this.state.isAuthenticated}  
                        paymentItem={this.state.paymentItem}    organizers404={this.state.organizers404}
                        />
                    }else{
                      return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                    }
              }} />
             
                
          
            

                <Route exact path="/"    render ={props =>{
                      if(this.state.errorAuth || !this.state.isAuthenticated){
                        if(this.state.pageLoading === false){
                            return   <Londing     noerorrpage={this.noerorrpage} />
                        }else{
                              return   <SignIn {...props} isAuthenticated={this.state.isAuthenticated} 
                        error={this.state.error} setGlobalAuthState={this.setGlobalAuthState}
                        checkUsercodition={this.checkUsercodition}
                         organizer={this.state.organizers}  
                        noerorrpage={this.noerorrpage}
                        organizers404={this.organizers404} 
                        setGlobalUser={this.getUser} 
                        // setGlobalorganizers={this.setGlobalorganizers}
                    />
                    }
                  
                    
                  }else
                    return    <Redirect to={{    pathname: `${'/dashboard'}`  }}/>
                  } }/>

                  <Route  path="/new-company" exact  render={ props => {
                              // console.log("is this suthenticated?", this.state.isAuthenticated)
                              if(!this.state.errorAuth || this.state.isAuthenticated){
                                    return    <NewCampany  {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                                      checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout} 
                                      isAuthenticated={this.state.isAuthenticated} error={this.state.error} 
                                      organizers404={this.state.organizers404}
                                      />   
                                }else{
                                  return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                              }
                    }} />

                 <Route  path="/products"  exact  render={ props => {
                              // console.log("is this suthenticated?", this.state.isAuthenticated)
                              if(!this.state.errorAuth || this.state.isAuthenticated){
                                    return    <Product {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                                      checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout} 
                                      isAuthenticated={this.state.isAuthenticated} error={this.state.error} 
                                      organizers404={this.state.organizers404}
                                      />   
                                }else{
                                  return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                              }
                    }} />


                   <Route  path="/product-new"  exact  render={ props => {
                              // console.log("is this suthenticated?", this.state.isAuthenticated)
                              if(!this.state.errorAuth || this.state.isAuthenticated){
                                    return    <NewProduct  {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                                      checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout} 
                                      isAuthenticated={this.state.isAuthenticated} error={this.state.error} 
                                      organizers404={this.state.organizers404}
                                      />   
                                }else{
                                  return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                              }
                    }} />


                  <Route  path="/product/:id"  exact  render={ props => {
                              // console.log("is this suthenticated?", this.state.isAuthenticated)
                              if(!this.state.errorAuth || this.state.isAuthenticated){
                                    return    <ProductDetail  {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                                      checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout} 
                                      isAuthenticated={this.state.isAuthenticated} error={this.state.error} 
                                      organizers404={this.state.organizers404}
                                      />   
                                }else{
                                  return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                              }
                    }} />



                <Route  path="/school"  exact  render={ props => {
                              // console.log("is this suthenticated?", this.state.isAuthenticated)
                              if(!this.state.errorAuth || this.state.isAuthenticated){
                                    return    <School {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                                      checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout} 
                                      isAuthenticated={this.state.isAuthenticated} error={this.state.error} 
                                      organizers404={this.state.organizers404}
                                      />   
                                }else{
                                  return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                              }
                    }} />


                    <Route  path="/company-profile"  exact  render={ props => {
                              // console.log("is this suthenticated?", this.state.isAuthenticated)
                              if(!this.state.errorAuth || this.state.isAuthenticated){
                                    return    <Profile {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                                      checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout} 
                                      isAuthenticated={this.state.isAuthenticated} error={this.state.error} 
                                      organizers404={this.state.organizers404}
                                      />   
                                }else{
                                  return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                              }
                    }} />


                 


                  {/* <Route path="/new-company"  exact  render={ props => {
                          return  <NewCampany  {...props }
                          noerorrpage={this.noerorrpage} organizer={this.state.organizers}
                    user={this.state.user} logout={this.logout} isAuthenticated={this.state.isAuthenticated}  
                    paymentItem={this.state.paymentItem}    organizers404={this.state.organizers404}
                    />    
                  }} /> */}

                <Route path="/company"  exact  render={ props => {
                        return  <Campany  {...props }
                        noerorrpage={this.noerorrpage} organizer={this.state.organizers}
                  user={this.state.user} logout={this.logout} isAuthenticated={this.state.isAuthenticated}  
                  paymentItem={this.state.paymentItem}    organizers404={this.state.organizers404}
                  />    
                }} />

            

                  {/* <Route path="/messages"  exact  render={ props => {
                            return  <Message  {...props }
                            noerorrpage={this.noerorrpage} organizer={this.state.organizers}
                            user={this.state.user} logout={this.logout} isAuthenticated={this.state.isAuthenticated}  
                            paymentItem={this.state.paymentItem}    organizers404={this.state.organizers404}
                      />    
                    }} />
 */}

                 
           
         
                    <Route path="/signup"  exact  render={ props => {
                        return  <Signup {...props } noerorrpage={this.noerorrpage}    />    
                     }} />

                    <Route path="/search"  exact  render={ props => {
                        return  <Search  {...props } noerorrpage={this.noerorrpage}    />    
                    }} />

             
                  <Route path="/about"  exact  render={ props => {
                      return  <AboutUs  {...props } noerorrpage={this.noerorrpage}    />    
                  }} />

                    <Route path="/careers"  exact  render={ props => {
                      return  <Career  {...props } noerorrpage={this.noerorrpage}    />    
                  }} />
                
                  <Route path="/bill"  exact  render={ props => {
                      return  <Bill  {...props } noerorrpage={this.noerorrpage}    />    
                  }} />


                <Route path="/e/:id/:title"  exact  render={ props => {
                      return  <Eventshow  {...props } noerorrpage={this.noerorrpage}    />    
                  }} />
                
              

    
              
                <Route path="/Home/:id"  exact  render={ props => {
                        return  <Public  {...props } closenav={this.closenav} noerorrpage={this.noerorrpage}    />    
                  }} />

                    <Route path="/contact/:id"  exact  render={ props => {
                        return  <Contact  {...props } closenav={this.closenav} noerorrpage={this.noerorrpage}   />    
                  }} />

                <Route path="/about/:id"  exact  render={ props => {
                        return  <About {...props } noerorrpage={this.noerorrpage}  closenav={this.closenav}  />    
                  }} />
                  <Route path="/news/:id"  exact  render={ props => {
                        return  <News  {...props } noerorrpage={this.noerorrpage}    />    
                  }} />

                  <Route path="/payment/:id"  exact  render={ props => {
                        return  <Payment  {...props } noerorrpage={this.noerorrpage}    />    
                  }} />


                <Route path="/testing"  exact  render={ props => {
                        return  <Testing  {...props } noerorrpage={this.noerorrpage}    />    
                  }} />

                <Route path="/testing1"  exact  render={ props => {
                        return  <Testing1 {...props } noerorrpage={this.noerorrpage}    />    
                  }} />
                      
        


    

   

              <Route  path="/infodisplay/:id" exact  render={ props => {
                      // console.log("is this suthenticated?", this.state.isAuthenticated)
                      if(!this.state.errorAuth || this.state.isAuthenticated){
                            return    <Display  {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers}  
                            checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout} 
                            isAuthenticated={this.state.isAuthenticated} error={this.state.error}
                            organizers404={this.state.organizers404}
                            />   
                        }else{
                          return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                      }
                }} />

            
        

                <Route  path="/categories" exact  render={ props => {
                  // console.log("is this suthenticated?", this.state.isAuthenticated)
                  if(!this.state.errorAuth || this.state.isAuthenticated){
                        return    < Category  {...props } noerorrpage={this.noerorrpage} checkUsercodition={this.checkUsercodition}  
                          user={this.state.user} logout={this.logout}  organizer={this.state.organizers}   
                           isAuthenticated={this.state.isAuthenticated}   organizers404={this.state.organizers404}
                          error={this.state.error}  />    
                    }else{
                      return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                  }
               }} />

            <Route  path="/catalog" exact  render={ props => {
                      // console.log("is this suthenticated?", this.state.isAuthenticated)
                      if(!this.state.errorAuth || this.state.isAuthenticated){
                            return    < Catalog  {...props } noerorrpage={this.noerorrpage} checkUsercodition={this.checkUsercodition}  
                              user={this.state.user} logout={this.logout}  organizer={this.state.organizers}   
                              isAuthenticated={this.state.isAuthenticated}   organizers404={this.state.organizers404}
                              error={this.state.error}  />    
                        }else{
                          return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                      }
              }} />




           
              <Route path="/activity" exact     render={ props=> {
                  if(!this.state.errorAuth || this.state.isAuthenticated){
                      return    < Activity   {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                      checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout} 
                      isAuthenticated={this.state.isAuthenticated} error={this.state.error} 
                      organizers404={this.state.organizers404}  
                      />
                      }else{
                        return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                    }
                  }}
            
                />

         <Route  path="/events/:id" exact  render={ props => {
                        // console.log("is this suthenticated?", this.state.isAuthenticated)
                        if(!this.state.errorAuth || this.state.isAuthenticated){
                              return    <Build  {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                                checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout} 
                                isAuthenticated={this.state.isAuthenticated} error={this.state.error} 
                                organizers404={this.state.organizers404}
                                />   
                          }else{
                            return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                        }
               }} />


              <Route  path="/event/new"  exact render ={ props => {
                        // console.log("is this suthenticated?", this.state.isAuthenticated)
                        if(!this.state.errorAuth || this.state.isAuthenticated){
                          return  <Eventcreate {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                            checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout}
                            isAuthenticated={this.state.isAuthenticated} error={this.state.error}
                            organizers404={this.state.organizers404}
                            />
                        }else{
                          return     <Redirect to={{    pathname: `${'/login'}`  }}/>
                        }
                    }} />

                <Route  path="/events" exact  render={ props =>{
                    // console.log("is this suthenticated?", this.state.isAuthenticated)
                  if(!this.state.errorAuth || this.state.isAuthenticated){
                          return  <FormBuild {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                            checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout}
                            isAuthenticated={this.state.isAuthenticated} error={this.state.error}
                            organizers404={this.state.organizers404}
                            />
                    }else{
                      return     <Redirect to={{    pathname: `${'/login'}`  }}/>
                    }
                  }} />
                  
                  <Route  path="/event/edit/:id" exact  render={ props =>{
                    // console.log("is this suthenticated?", this.state.isAuthenticated)
                  if(!this.state.errorAuth || this.state.isAuthenticated){
                          return  <Eventedit {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                            checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout}
                            isAuthenticated={this.state.isAuthenticated} error={this.state.error}
                            organizers404={this.state.organizers404}
                            />
                    }else{
                      return     <Redirect to={{    pathname: `${'/login'}`  }}/>
                    }
                  }} />

                  <Route  path="/form/builder/:id" exact  render={ props =>{
                                      // console.log("is this suthenticated?", this.state.isAuthenticated)
                      if(!this.state.errorAuth || this.state.isAuthenticated){
                              return  <Eventform {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                                checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout}
                                isAuthenticated={this.state.isAuthenticated} error={this.state.error}
                                organizers404={this.state.organizers404}
                                />
                        }else{
                          return     <Redirect to={{    pathname: `${'/login'}`  }}/>
                        }
                    }} />


      
                  <Route  path="/setting" exact  render={ props => {
                        // console.log("is this suthenticated?", this.state.isAuthenticated)
                        if(!this.state.errorAuth || this.state.isAuthenticated){
                                return    <Setting  {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                                checkUsercodition={this.checkUsercodition}  user={this.state.user} logout={this.logout}
                                  isAuthenticated={this.state.isAuthenticated} error={this.state.error}
                                  organizers404={this.state.organizers404} />
                          }else{
                            return    <Redirect to={{    pathname: `${'/login'}`  }}/>
                        }
                    }} />


                  <Route  path="/update-info"  exact render ={ props => {
                      // console.log("is this suthenticated?", this.state.isAuthenticated)
                      if(!this.state.errorAuth || this.state.isAuthenticated){
                          return  < MoreSetting {...props } noerorrpage={this.noerorrpage} organizer={this.state.organizers} 
                          user={this.state.user} logout={this.logout}   isAuthenticated={this.state.isAuthenticated}
                          organizers404={this.state.organizers404}
                            error={this.state.error}  />
                      }else{
                        return     <Redirect to={{    pathname: `${'/login'}`  }}/>
                      }
                  }} />

                <Route path="/info" exact     render={ props=> {
                    if(!this.state.errorAuth || this.state.isAuthenticated){
                      return   < Info {...props }  noerorrpage={this.noerorrpage}  user={this.state.user} 
                      logout={this.logout} isAuthenticated={this.state.isAuthenticated} error={this.state.error}
                      organizers404={this.state.organizers404}
                      // setGlobalorganizers={this.setGlobalorganizers}
                      />
                        }else{
                          return     <Redirect to={{    pathname: `${'/login'}`  }}/>
                      }
                    }}
              
                  />

          <Route exact path="/login"    render ={props =>{
            if(this.state.errorAuth || !this.state.isAuthenticated){
              if(this.state.pageLoading === false){
                  return   <Londing     noerorrpage={this.noerorrpage} />
              }else{
                    return   <SignIn {...props} isAuthenticated={this.state.isAuthenticated} 
              error={this.state.error} setGlobalAuthState={this.setGlobalAuthState}
              checkUsercodition={this.checkUsercodition}
              noerorrpage={this.noerorrpage}
              organizers404={this.organizers404} 
              setGlobalUser={this.getUser} 
              // setGlobalorganizers={this.setGlobalorganizers}
              setGlobalpayer={this.setGlobalpayer}
              />
              }
            
              
            }else
              return    <Redirect to={{    pathname: `${'/dashboard'}`  }}/>
            } }/>

              {
              !this.state.noerorrpage ?
              <Route  exact path="*" component={Page404}/>
              :
              <div></div>
              }

          
        </div>
       
       
     
        
      </Router>
    );
  }
}


// const NoMatch = ({ location }) => (
//   <div style={{ marginTop: '4%'}} >
//     <h3>No match for <code>{location.pathname}</code></h3>
//   </div>
// )

export default App;






// WEBPACK FOOTER //
// ./src/App.js